module.exports = __webpack_public_path__ + "static/media/Income.eb2e5c4f.png";